import ServiceTabs from '../components/service-tabs.svelte'
// import lozad from 'lozad'
// import Test from '../components/test/example.svelte'

const { $ } = window

export default {
	init() {
		let $stiTabs = $('#sti_tabs')

		// new Test({ target: document.body })

		if ($stiTabs.length) {
			new ServiceTabs({
				target: $stiTabs[0],
				props: $stiTabs.data(),
			})
		}
	},
	// finalize() {
	// 	let observer = lozad()
	// 	observer.observe()
	// },
}
